module.exports = __webpack_public_path__ + "img/title-dec-dark.7b37e688.png";